export default {"src":"/_next/static/media/wordart.d1368b17.svg","height":650,"width":1700};